// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Yl-z","sponsoredTooltipWrapper":"Zl-z","sponsoredTooltip":"_l-z","newCard":"am-z"};